import request from 'superagent/lib/client';
import {
    API_HOST,
    API_ENV,
} from '@/constant';
import store from '@/store';
import generateUUID from '@/utils/uuid';
import apiMapping from '@/api/apiMapping';

const API_VERSION = require('../../package.json').apiVersion;
const appVersion = require('../../package.json').version;

const APP_NAME = 'store';

export const APP_VERSION = appVersion;

export const resolveApi = (apiName) => {
    const regex = new RegExp(/(http:\/\/|https:\/\/)/g);
    const absoluteAddr = regex.test(apiName);

    // 传入的为绝对请求路径，直接返回
    if (absoluteAddr) return apiName;

    // 传入的为api name，到mapping处找出对应的url
    const apiUrl = apiMapping[apiName];

    if (!apiUrl) {
        throw new Error(`没有找到对应的api路径，请检查API名称：${apiName} 是否正确`);
    }

    const formatUrl = apiUrl[0] !== '/' ? `/${apiUrl}` : apiUrl;
    const apiHost = API_HOST[API_ENV];

    return apiHost + formatUrl;
};

export const resolveExportUrl = (apiName) => {
    const url = resolveApi(apiName);
    return `${url}?api_version=${API_VERSION}&token=${store.state.appInfo.token}`;
};

export const getB2BUrl = () => {
    const obj = {
        release: 'https://b2b.carisok.com',
        abtest : 'https://abtest-b2b.carisok.com',
        beta   : 'https://test-b2b.carisok.com',
        albeta : 'https://beta-b2b.carisok.com',
        alpha  : 'http://192.168.1.206/b2b/'
    };
    return obj[process.env.API_ENV];
};

export const configParams = (reqParams) => {
    const params = {};
    // const token = (ENV === 'testing' || API_ENV !== 'release')
    //             ? Math.ceil(Math.random() * 100000).toString()
    //             : store.state.auth.token;

    // 加入共同参数
    Object.assign(params, reqParams, {
        api_version: API_VERSION,
        __trace_id: generateUUID(APP_NAME),
        token: store.state.appInfo.token,
    });

    return params;
};

export const configAjax = (options) => {
    const { httpMethod, apiName, reqParams } = options;
    let ajaxTimeout = 20000;
    // const ajaxTimeout = 200; // 测试timeout用的时间限制
    // worderOrderFinish接车/finishOrder收银/createCardOrder营销售卡/createChargeOrder储值卡
    if (apiName === 'finishOrder' || apiName === 'worderOrderFinish' || apiName === 'createCardOrder' || apiName === 'createChargeOrder') {
        ajaxTimeout = 60000;
    }

    const ajax = request[httpMethod](resolveApi(apiName))
        .timeout(ajaxTimeout)
        .accept('application/json');

    if (httpMethod === 'get') {
        ajax.query(reqParams);
    } else {
        const serializeType = 'application/x-www-form-urlencoded';
        const reqParamsStr = request.serialize[serializeType](reqParams);
        ajax.send(reqParamsStr);
    }

    return ajax;
};



// WEBPACK FOOTER //
// ./src/http/helpers.js